import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Loader2 } from 'lucide-react';

/**
 * Spec 007b — renders a Swish payment QR client-side from the payment-request payload (a `swish://` deep
 * link built from the single-use token). Kept on an ALWAYS-LIGHT panel so it scans in dark mode too — a
 * deliberate exception to the theme, because a QR must be dark-on-light to read. The image carries a full
 * text alternative; if generation fails the component renders nothing and the page shows its link fallback.
 */
export function SwishQr({ payload, alt }: { payload: string; alt: string }) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    QRCode.toDataURL(payload, { margin: 1, width: 232, errorCorrectionLevel: 'M' })
      .then((url) => {
        if (active) setSrc(url);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [payload]);

  if (failed) return null;

  return (
    <div className="mx-auto flex h-64 w-64 items-center justify-center rounded-md border border-border bg-white p-4 shadow-sm">
      {src ? (
        <img src={src} alt={alt} width={232} height={232} className="h-full w-full" />
      ) : (
        <Loader2 aria-hidden className="h-8 w-8 animate-spin text-muted" />
      )}
    </div>
  );
}
